import { Component, h, Prop } from '@stencil/core';
import { Success } from "../../../../redux/types";
import { ButtonAppearance, ButtonSize, ButtonStyle } from '../../../atoms/rentware-button/types';

@Component({
    tag: 'rentware-checkout-success-template',
    styleUrl: 'style.sass',
    shadow: true,
})
export class RentwareCheckoutSuccessTemplate {
    @Prop() success: Success;
    @Prop() cartState;
    @Prop() onOpenBooking;
    @Prop() thanksText;
    @Prop() bookingReferenceText;
    @Prop() openBookingText;
    @Prop() confirmationEmailText;

    get buttonAppearance(): ButtonAppearance {
        return {
            style: ButtonStyle.Inverse,
            fullWidth: true,
            size: ButtonSize.XL,
        };
    }

    render() {
        if (!this.success) {
            return null;
        }

        return (
            <div class="SuccessContainer">
                <div class="SuccessContainerInner">
                    <rentware-spacer size="XL" />

                    <svg width="60" height="60" viewBox="0 0 60 60" fill="none" xmlns="http://www.w3.org/2000/svg">
                        <circle cx="30" cy="30" r="30" />
                        <path d="M18 33.6064L24.6462 40.5L42 22.5" stroke-width="2"
                            stroke-linecap="round" stroke-linejoin="round" />
                    </svg>

                    <rentware-spacer size="S" />

                    <div class="TextItem">
                        <span class="Thanks">
                            {this.thanksText}
                        </span>
                    </div>

                    <rentware-spacer size="M" />

                    <div class="TextItem" innerHTML={this.confirmationEmailText} />

                    <div class="SpacerDesktop" />

                    <rentware-spacer size="XL" />

                    <div class="GreyContainer">
                        <rentware-spacer size="M" />

                        {this.bookingReferenceText}

                        <rentware-spacer size="S" />

                        <div class="Reference">
                            #{this.success.order.reference}
                        </div>

                        <rentware-spacer size="S" />

                        <rentware-divider />

                        <rentware-spacer size="S" class="DesktopOnly" />

                        <div class="SuccessButtonContainer">
                            <rentware-button
                                appearance={this.buttonAppearance}
                                buttonText={this.openBookingText}
                                onClick={this.onOpenBooking}
                            />
                        </div>

                        <rentware-spacer-xl class="MobileOnly" />
                    </div>
                </div>
            </div>
        )
    }
}

